module.exports = __webpack_public_path__ + "static/media/east-timor.a7e8ee40.png";